export default __webpack_public_path__ + "static/108118-bb9634f0f87a6fa3a8eea843203d0dc6.jpg";